var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 2.375C6.1025 2.375 2.75 5.7275 2.75 9.875C2.75 14.0225 6.1025 17.375 10.25 17.375C14.3975 17.375 17.75 14.0225 17.75 9.875C17.75 5.7275 14.3975 2.375 10.25 2.375ZM14 12.5675L12.9425 13.625L10.25 10.9325L7.5575 13.625L6.5 12.5675L9.1925 9.875L6.5 7.1825L7.5575 6.125L10.25 8.8175L12.9425 6.125L14 7.1825L11.3075 9.875L14 12.5675Z",
    fill: "#7D8592"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2523_530",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 2.375C6.1025 2.375 2.75 5.7275 2.75 9.875C2.75 14.0225 6.1025 17.375 10.25 17.375C14.3975 17.375 17.75 14.0225 17.75 9.875C17.75 5.7275 14.3975 2.375 10.25 2.375ZM14 12.5675L12.9425 13.625L10.25 10.9325L7.5575 13.625L6.5 12.5675L9.1925 9.875L6.5 7.1825L7.5575 6.125L10.25 8.8175L12.9425 6.125L14 7.1825L11.3075 9.875L14 12.5675Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2523_530)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.b20a89819976d492d4467efff1f42c88.svg";
export { ForwardRef as ReactComponent };